/* eslint-disable */
import { gql } from '@apollo/client'

// GraphQL query for dashboard data
export const getDashboardData = gql`
  query GetDashboardData($input: dashboardInput!) {
    getDashBoardData(input: $input) {
      status
      message
      activePatients {
        _id
        patientid
        firstname
        lastname
        lastActivityDate
        createdAt
        application
        actiontype
        action
        method
        collection_name
        customerid
      }
      activityPatients {
        _id
        patientid
        firstname
        lastname
        lastActivityDate
        createdAt
        application
        actiontype
        action
        method
        collection_name
        customerid
      }
      newPatients {
        _id
        patientid
        firstname
        lastname
        lastActivityDate
        createdAt
        application
        actiontype
        action
        method
        collection_name
        customerid
      }
      registeredPatients {
        _id
        patientid
        firstname
        lastname
        lastActivityDate
        createdAt
        application
        actiontype
        action
        method
        collection_name
        customerid
        provider
        loginStatus
        lastActiveAt
      }
      adminWebLogins
      adminAppLogins
      adminWebLoginDetails {
        _id
        userid
        name
        role
        customerName
        companyName
        createdAt
        application
      }
      adminAppLoginDetails {
        _id
        userid
        name
        role
        customerName
        companyName
        createdAt
        application
      }
    }
  }
`

// GraphQL query for the Patient Feedback card (Super-Admin only).
export const getPatientFeedbackData = gql`
  query GetPatientFeedback {
    getPatientFeedback {
      status
      message
      average
      total
      items {
        patientid
        patientName
        customerid
        clinicName
        rating
        comment
        createdAt
      }
    }
  }
`

// GraphQL query for the Logged-In Patients card (Company Admin only).
// ALL patients with a live session (not logged out), each tagged active/away.
export const getLoggedInPatientsData = gql`
  query GetLoggedInPatients {
    getLoggedInPatients {
      status
      message
      total
      data {
        _id
        name
        clinic
        customerid
        lastActiveAt
        loginStatus
      }
    }
  }
`

// Service methods
export const dashboardService = {
  // Format the dashboard data
  formatDashboardData: (data) => {
    if (!data) return null
    return {
      activePatients: data.activePatients || [],
      activityPatients: data.activityPatients || [],
      newPatients: data.newPatients || [],
      status: data.status,
      message: data.message,
    }
  },

  // Get date label from value
  getDateLabel: (value) => {
    const labels = {
      '1d': '1 day',
      '3d': '3 days',
      '7d': '7 days',
      '15d': '15 days',
      '1m': '1 month',
      '2m': '2 months',
      '3m': '3 months',
    }
    return labels[value] || value
  },
}

export default dashboardService